import React from 'react';
import Icon from 'components/AppIcon';

const ACTIVITY_STYLES = {
  MEMBER_JOINED: { icon: 'UserPlus', color: 'text-green-400', bg: 'bg-green-500/10', label: 'joined the faction' },
  VAULT_DEPOSIT: { icon: 'Vault', color: 'text-blue-400', bg: 'bg-blue-500/10', label: 'deposited to vault' },
  WAR_DECLARED: { icon: 'Swords', color: 'text-red-400', bg: 'bg-red-500/10', label: 'declared war' },
  TERRITORY_CAPTURED: { icon: 'Flag', color: 'text-purple-400', bg: 'bg-purple-500/10', label: 'captured territory' },
  MEMBER_PROMOTED: { icon: 'Star', color: 'text-yellow-400', bg: 'bg-yellow-500/10', label: 'was promoted' },
};

const ActivityFeedItem = ({ activity }) => {
  const style = ACTIVITY_STYLES?.[activity?.activity_type] || {
    icon: 'Activity',
    color: 'text-muted-foreground',
    bg: 'bg-muted',
    label: 'performed an action',
  };

  const time = activity?.created_at
    ? new Date(activity.created_at)?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : '';

  const username =
    activity?.user_profiles?.username ||
    activity?.activity_data?.username ||
    'A member';

  return (
    <div className="flex items-center gap-2 py-1.5 px-2 rounded-lg hover:bg-muted/30 transition-colors">
      <div className={`w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 ${style?.bg}`}>
        <Icon name={style?.icon} size={12} className={style?.color} />
      </div>
      <p className="flex-1 text-xs text-muted-foreground min-w-0">
        <span className="font-medium text-foreground">{username}</span>{' '}
        {style?.label}
        {activity?.activity_data?.amount && (
          <span className="text-green-400 font-medium">
            {' '}${Number(activity?.activity_data?.amount)?.toLocaleString()}
          </span>
        )}
      </p>
      <span className="text-xs text-muted-foreground flex-shrink-0">{time}</span>
    </div>
  );
};

export default ActivityFeedItem;
